module.exports = __webpack_public_path__ + "img/small_t3_fine_nut.prt.451e5a2d.jpg";